import {HttpContextToken} from '@angular/common/http'
import {environment} from '../../../environments/environment'
import {ttlToMilliseconds} from '../util'

export const CACHING_ENABLED = new HttpContextToken<boolean>(() => false)
export const CACHING_TTL = new HttpContextToken<number>(() => ttlToMilliseconds(environment.cache?.maxAge ?? '1h'))
export const CACHE_FORCE_REFRESH = new HttpContextToken<boolean>(() => false)
export const CACHING_DEFAULT_TTL = ttlToMilliseconds(environment.cache?.maxAge ?? '1h')
